import { useContext as r, useMemo as s } from "react";
import { IressSlideoutContext as i } from "../SlideoutProvider.js";
const n = () => {
  const o = r(i);
  return s(
    () => ({
      showSlideout: (e, t = !0) => {
        if (o === void 0)
          throw new Error(
            "IressSlideout: showSlideout must be used within a IressSlideoutProvider"
          );
        o.showSlideout(e, t);
      }
    }),
    [o]
  );
};
export {
  n as useSlideout
};
